import React from "react";
import {Helmet} from "react-helmet";
import {MichaelIsles} from "../../constants/meta";

export const A31Meta = () => (
    <Helmet>
        <title>Fred Garwood | Vieunite </title>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Fred Garwood"/>
        <meta name="twitter:description"
              content=". Fred’s fascination with the contrast and play of light and colour fuels his creativity, allowing him to capture the intricate details and emotions in every frame. His expertise and keen eye for detail ensure that every photograph is a masterpiece. "/>
        <meta name="twitter:url" value="https://vieunite.com/artists/fred-garwood"/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_fred_garwood.jpg"/>

        <meta property="og:url" content="https://vieunite.com/artists/fred-garwood"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Fred Garwood"/>
        <meta property="og:description"
              content=" Fred’s fascination with the contrast and play of light and colour fuels his creativity, allowing him to capture the intricate details and emotions in every frame. His expertise and keen eye for detail ensure that every photograph is a masterpiece. "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ fred_garwood.jpg"/>


    </Helmet>);